
export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatDate = (dateString: string) => {
  if (!dateString) return "Not set";
  try {
    return new Date(dateString).toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  } catch {
    return "Invalid date";
  }
};

export const formatDuration = (days?: number) => {
  if (!days && days !== 0) return "Not specified";
  if (days === 1) return "1 day";
  return `${days} days`;
};

export const calculatePriceToCustomer = (totalCost: number, profitMargin: number, bufferPercent: number) => {
  const bufferMultiplier = 1 + (bufferPercent / 100);
  const totalWithAdjustedBuffer = totalCost * bufferMultiplier;
  return totalWithAdjustedBuffer * (1 + profitMargin / 100);
};

export const calculateAdjustedBufferAmount = (totalCost: number, bufferPercent: number) => {
  return totalCost * (bufferPercent / 100);
};

export const calculateTotalWithAdjustedBuffer = (totalCost: number, bufferPercent: number) => {
  return totalCost + calculateAdjustedBufferAmount(totalCost, bufferPercent);
};

export const calculateAverageCostPerTask = (totalCost: number, numTasks: number) => {
  return numTasks > 0 ? Math.round(totalCost / numTasks) : 0;
};

export const calculateOverallBlendedRate = (resourceAssignments: any[], profitMargin: number, bufferPercent: number) => {
  if (!resourceAssignments || resourceAssignments.length === 0) return 0;
  
  // Step 1-3: Calculate Total Project Cost
  // For each resource in each task: Rate × Hours × Duration
  let totalProjectCost = 0;
  
  // Step 4-6: Calculate Total Project Hours 
  // For each resource in each task: Hours × Duration
  let totalProjectHours = 0;
  
  resourceAssignments.forEach(assignment => {
    const rate = assignment.rate || 0;
    const duration = assignment.duration || 0;
    const allocationHours = parseFloat(assignment.allocation_hrs) || 0;
    const allocatedPercentage = assignment.allocated_percentage || 100;
    
    // Step 1-3: Calculate resource cost (Rate × Allocation% × Hours × Duration)
    const resourceCost = rate * (allocatedPercentage / 100) * allocationHours * duration;
    totalProjectCost += resourceCost;
    
    // Step 4-6: Calculate resource hours (Hours × Duration)
    const resourceHours = allocationHours * duration;
    totalProjectHours += resourceHours;
  });
  
  // Step 7: Calculate Base Blended Rate = Total Project Cost ÷ Total Project Hours
  const baseBlendedRate = totalProjectHours > 0 ? totalProjectCost / totalProjectHours : 0;
  
  // Step 8: Apply buffer percentage and profit margin to derive Blended Rate to Customer
  const bufferMultiplier = 1 + (bufferPercent / 100);
  const blendedRateWithBuffer = baseBlendedRate * bufferMultiplier;
  const blendedRateToCustomer = blendedRateWithBuffer * (1 + profitMargin / 100);
  
  console.log('📊 BLENDED RATE CALCULATION:', {
    totalProjectCost,
    totalProjectHours,
    baseBlendedRate,
    bufferPercent,
    profitMargin,
    blendedRateWithBuffer,
    blendedRateToCustomer
  });
  
  return blendedRateToCustomer;
};
